import { Link } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import * as S from "./styled";
import { useAuth } from "../../context/auth";
import { useSidebar } from "../../template";
import { clearApplicationCache } from "../../utils/cacheUtils";
import api from "../../services/api";

import LogoTop from "../../assets/logo_navbar.png";

import { Image, Alert } from "react-bootstrap";

const IA_PLANS = new Set(["TESTE", "ESSENCIAL", "PLUS", "VIP", "PREMIUM"]);

function Menu() {
  const { user, setUser } = useAuth();
  const [hasRedacoesCorrigidas, setHasRedacoesCorrigidas] = useState(false);

  // Fallback para quando o contexto não estiver disponível
  let sidebarOpen = false;
  let setSidebarOpen = () => { };

  try {
    const sidebarContext = useSidebar();
    sidebarOpen = sidebarContext.sidebarOpen;
    setSidebarOpen = sidebarContext.setSidebarOpen;
  } catch (error) {
    // Contexto não disponível, usar valores padrão
  }

  const plan = user?.plano;
  const isPresencialAluno = (user?.nivel === "e" && plan === "PRESENCIAL") || plan === "ZOOM";
  const isOnlineIAAluno = (user?.nivel === "e" || user?.nivel === "t") && IA_PLANS.has(plan);

  const isTesteAluno =
    plan === "TESTE" || user?.type === "t";

  const isZoomAluno = plan === "ZOOM";

  const enviarRedacaoPath = isTesteAluno
    ? "/upload-redacao-teste" // tela antiga de teste
    : "/enviar-redacao";      // tela nova dos planos pagos

  // Verificar se usuário tipo 't' tem redações corrigidas
  useEffect(() => {
    if (user && user.nivel === "t") {
      const checkRedacoesCorrigidas = async () => {
        try {
          const response = await api.get("/redacoes");
          if (response.data && response.data[0] && response.data[0].total > 0) {
            setHasRedacoesCorrigidas(true);
          } else {
            setHasRedacoesCorrigidas(false);
          }
        } catch (error) {
          console.error("Erro ao verificar redações corrigidas:", error);
          setHasRedacoesCorrigidas(false);
        }
      };
      checkRedacoesCorrigidas();
    }
  }, [user]);

  const closeOnMobile = () => window.innerWidth < 768 && setSidebarOpen(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  function logout() {
    localStorage.removeItem("token");
    setUser({});
    clearApplicationCache("logout-manual");
    window.location.href = "/login";
  }

  return (
    <>
      {/* Header fixo */}
      <S.TopHeader>
        <S.MenuToggle isOpen={sidebarOpen} onClick={toggleSidebar}>
          <span></span>
        </S.MenuToggle>

        <S.LogoContainer sidebarOpen={sidebarOpen}>
          <Link to="/logado">
            <Image src={LogoTop} height="40" />
          </Link>
        </S.LogoContainer>

        <S.UserInfo>
          <span>Bem vindo(a) {user?.nome}</span>
          <Link to="/logado" className="profile-link">
            <S.ProfileIcon /> Perfil
          </Link>
          <Link onClick={logout} to="/login" className="logout-link">
            <S.LogoutIcon /> Sair
          </Link>
        </S.UserInfo>
      </S.TopHeader>

      {sidebarOpen && <S.Overlay onClick={toggleSidebar} />}

      <S.Sidebar isOpen={sidebarOpen}>
        <S.SidebarContent>
          <S.NavSection>
            {/* Home */}
            <S.NavItem>
              <Link to="/logado" className="nav-link" onClick={closeOnMobile}>
                <S.HomeIcon /> Home
              </Link>
            </S.NavItem>

            {/* Correção (admin/corretores) - mantido */}
            {(user.nivel === "a" || user.nivel === "c") && (
              <S.NavSection>
                <S.SectionTitle>Correção</S.SectionTitle>
                <S.NavItem>
                  <Link to="/redacoes" className="nav-link" onClick={closeOnMobile}>
                    <S.NewsPapperIcon /> Redações
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/redacoes-uerj" className="nav-link" onClick={closeOnMobile}>
                    <S.NewsPapperIcon /> Redações - UERJ
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/correcao-ia-humano" className="nav-link" onClick={closeOnMobile}>
                    <S.NewsPapperIcon /> Correção IA + Humano
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/competencias" className="nav-link" onClick={closeOnMobile}>
                    <S.NewsPapperIcon /> Competências
                  </Link>
                </S.NavItem>
                {user.nivel === "a" && (
                  <S.NavItem>
                    <Link to="/corretores" className="nav-link" onClick={closeOnMobile}>
                      <S.NewsPapperIcon /> Corretores
                    </Link>
                  </S.NavItem>
                )}
              </S.NavSection>
            )}

            {/* =========================
                ESTUDANTE - PRESENCIAL
               ========================= */}
            {(user.nivel === "a" || user.plano === "PREMIUM" || isPresencialAluno) && (
              <S.NavSection>
                <S.SectionTitle>Estudante</S.SectionTitle>

                {/* presencial mantém o menu antigo */}
                <S.NavItem>
                  <Link to="/classe" className="nav-link" onClick={closeOnMobile}>
                    <S.ClassIcon /> Minha Classe
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/medias" className="nav-link" onClick={closeOnMobile}>
                    <S.ClassIcon /> Minha Média
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/materiais" className="nav-link" onClick={closeOnMobile}>
                    <S.ClassIcon /> Materiais
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/minhas-redacoes" className="nav-link" onClick={closeOnMobile}>
                    <S.NewsPapperIcon /> Minhas Redações
                  </Link>
                </S.NavItem>
              </S.NavSection>
            )}

            {
              /*
                  ESTUDANTE - ONLINE / IA
              */
            }
            {isOnlineIAAluno && (
              <S.NavSection>
                <S.SectionTitle>Estudante</S.SectionTitle>

                <S.NavItem>
                  <Link to="/minhas-redacoes" className="nav-link" onClick={closeOnMobile}>
                    <S.NewsPapperIcon /> Minhas Redações
                  </Link>
                </S.NavItem>

                <S.NavItem>
                  <Link to="/medias" className="nav-link" onClick={closeOnMobile}>
                    <S.ClassIcon /> Minha Média
                  </Link>
                </S.NavItem>

                <S.NavItem>
                  <Link to="/materiais" className="nav-link" onClick={closeOnMobile}>
                    <S.ClassIcon /> Materiais
                  </Link>
                </S.NavItem>

                <S.NavItem>
                  <Link
                    to={enviarRedacaoPath}
                    className="nav-link"
                    onClick={closeOnMobile}
                  >
                    <S.NewsPapperIcon /> Enviar Redação IA
                  </Link>
                </S.NavItem>

              </S.NavSection>
            )}

            {/* Monitoria - apenas PRESENCIAL. alunos do tipo de plan === ZOOM nao deve aparecer */}
            {(user.nivel === "a" || user.nivel === "m" || (isPresencialAluno && !isZoomAluno)) && (
              <S.NavSection>
                <S.SectionTitle>Monitoria</S.SectionTitle>
                <S.NavItem>
                  <Link to="/mentoria" className="nav-link" onClick={closeOnMobile}>
                    <S.ChatIcon /> Monitoria
                  </Link>
                </S.NavItem>
                {user.nivel === "a" && (
                  <S.NavItem>
                    <Link to="/monitores" className="nav-link" onClick={closeOnMobile}>
                      <S.ChatIcon /> Monitores
                    </Link>
                  </S.NavItem>
                )}
                {(user.nivel === "a" || user.nivel === "m") && (
                  <S.NavItem>
                    <Link to="/listamentoria" className="nav-link" onClick={closeOnMobile}>
                      <S.ChatIcon /> Lista Monitoria
                    </Link>
                  </S.NavItem>
                )}
              </S.NavSection>
            )}

            {/* PAGAMENTOS (online e presencial) */}
            {(user.nivel === "e" || user.nivel === "t") && (
              <S.NavSection>
                <S.SectionTitle>Pagamentos</S.SectionTitle>
                <S.NavItem>
                  <Link to="/meus-pagamentos" className="nav-link" onClick={closeOnMobile}>
                    <S.PaymentIcon /> Meus Pagamentos
                  </Link>
                </S.NavItem>

                {/* Planos */}
                {IA_PLANS.has(plan) && (
                  <S.NavItem>
                    <Link to="/planos" className="nav-link" onClick={closeOnMobile}>
                      <S.PlanosIcon /> Planos
                    </Link>
                  </S.NavItem>
                )}
              </S.NavSection>
            )}

            {/* E-books */}
            <S.NavSection>
              <S.SectionTitle>E-books</S.SectionTitle>
              <S.NavItem>
                <Link to="/meus-ebooks" className="nav-link" onClick={closeOnMobile}>
                  <S.BookIcon /> Meus E-books
                </Link>
              </S.NavItem>
              <S.NavItem>
                <Link to="/comprar-ebooks" className="nav-link" onClick={closeOnMobile}>
                  <S.BookIcon /> Comprar E-books
                </Link>
              </S.NavItem>
            </S.NavSection>

            {/* Seção de Administração */}
            {user.nivel === "a" && (
              <S.NavSection>
                <S.SectionTitle>Administração</S.SectionTitle>
                <S.NavItem>
                  <Link to="/usuarios" className="nav-link" onClick={closeOnMobile}>
                    <S.UsersIcon /> Usuários
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/contratos" className="nav-link" onClick={closeOnMobile}>
                    <S.ContratoIcon /> Contratos
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/avisos-entrega" className="nav-link" onClick={closeOnMobile}>
                    <S.AvisoEntregaIcon /> Avisos de Entrega
                  </Link>
                </S.NavItem>
                <S.NavItem>
                  <Link to="/produtividade" className="nav-link" onClick={closeOnMobile}>
                    <S.ReportIcon /> Produção por Corretor
                  </Link>
                </S.NavItem>
                {(user.id === 413 || user.id === 1668) && (
                  <>
                    <S.NavItem>
                      <Link to="/relatorios" className="nav-link" onClick={closeOnMobile}>
                        <S.ReportIcon /> Relatórios
                      </Link>
                    </S.NavItem>
                    <S.NavItem>
                      <Link to="/admin/planos-temas" className="nav-link" onClick={closeOnMobile}>
                        <S.TemaIcon /> Temas por Plano
                      </Link>
                    </S.NavItem>
                  </>
                )}
              </S.NavSection>
            )}

            {/* Suporte / Contato (mantido) */}
            {(user.nivel === "e" || user.nivel === "t") && (
              <S.NavSection>
                <S.SectionTitle>Suporte / Contato</S.SectionTitle>
                <S.NavItem>
                  <Link to="/suporte" className="nav-link" onClick={closeOnMobile}>
                    <S.ChatIcon /> Suporte / Contato
                  </Link>
                </S.NavItem>
              </S.NavSection>
            )}
          </S.NavSection>
        </S.SidebarContent>
      </S.Sidebar>
    </>
  );
}

export default Menu;